import React from "react";
import { SearchBox } from "@elastic/react-search-ui";
import { createUseStyles } from "react-jss";


const useStyles = createUseStyles((theme) => ({
  searchBar: {
    composes: 'flex1 stretchSelf',
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
    '& > form': {
      width: '100%',
    },
  },
}));

const SearchBar = () => {
  const classes = useStyles();

  return (
    <div className={classes.searchBar}>
      <SearchBox
        autocompleteSuggestions={true}
        autocompleteResults={{
          sectionTitle: 'Suggestions de requetes',
          titleField: 'title',
          urlField: 'nps_link',
        }} 
        inputProps={{ placeholder: 'Directeur commercial' }}
      />
    </div>
  );
}

export default SearchBar;